<template>
    <div id="loader" :class="{'loader': true, 'hide': !isLoading}">
        <div class="wrapper">
            <div class="circle"><div></div><div></div></div>
        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
    name: 'Loader',

    computed: mapState({
        isLoading: state => state.loader.main.isLoading
    })
}
</script>
